

import React from 'react';
import classes from "./styles.module.scss";
import Title from '@/ui/Title';
import Link from 'next/link';
import Image from "@/ui/Image";

const ProjectCard = ({project}) => {
  return <Link className={classes.card} href={`/projects/${project.url_slug}`}>
    <Image img={project.image} size="590x411" alt={project.name} className={classes.image} />
    <div className={classes.overlay}></div>
    <div className={classes.details}>
      <Title title={project.name} className={classes.title} tag="h5" />
    </div>
  </Link>
}

export default ProjectCard